// Angular
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Medsurf Lib
import { FlatDesignModule } from '@medsurf/flat-designs';
import { MedsurfCommonModule } from '../common/medsurf-common.module';
// Components
import { ChapterComponent } from './chapter.component';
import { ChapterMainComponent } from './main/chapter-main.component';
import { BodyComponent } from './main/body/body.component';
import { CommentsComponent } from './main/comments/comments.component';
import { DescriptionComponent } from './main/description/description.component';
import { ExportComponent } from './main/export/export.component';
import { QuizStartComponent } from './main/quiz-start/quiz-start.component';
import { SettingsComponent } from './main/settings/settings.component';
import { GenerateComponent } from './main/generate/generate.component';
import { SlidesComponent } from './main/slides/slides.component';
import { VocabularyComponent } from "./main/vocabulary/vocabulary.component";
import { VocabularyWordDialogComponent } from "./main/vocabulary/vocabulary-word-dialog/vocabulary-word-dialog.component";

@NgModule({
  imports: [
    // Angular
    CommonModule,
    NgOptimizedImage,
    // Bootstrap
    NgbModule,
    // Translate
    TranslateModule.forChild(),
    // Modules
    MedsurfCommonModule,
    FlatDesignModule,
  ],
  exports: [
    ChapterComponent
  ],
  declarations: [
    // Components
    ChapterComponent,
    ChapterMainComponent,
    BodyComponent,
    CommentsComponent,
    DescriptionComponent,
    ExportComponent,
    QuizStartComponent,
    SettingsComponent,
    GenerateComponent,
    SlidesComponent,
    VocabularyComponent,
    VocabularyWordDialogComponent,
  ],
})
export class ChapterModule {
}
